import Vue from "vue";
import {
  Button,
  Tab,
  Tabs,
  Form,
  Field,
  Checkbox,
  CheckboxGroup,
  Toast,
  Dialog,
  Icon,
  Grid,
  GridItem,
  ImagePreview,
  Empty,
  Lazyload,
  PullRefresh,
  ShareSheet,
  Radio,
  RadioGroup,
  Search,
  Popup,
  List,
  NavBar,
  Swipe,
  SwipeItem,
  Cell,
} from "vant";
Vue.use(Cell);
Vue.use(Button);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Form);
Vue.use(Field);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Icon);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(ImagePreview);
Vue.use(Empty);
Vue.use(Lazyload);
Vue.use(PullRefresh);
Vue.use(ShareSheet);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Search);
Vue.use(Popup);
Vue.use(List);
Vue.use(NavBar);
Vue.use(Swipe);
Vue.use(SwipeItem);
